import api from "@/api/axios";

const API_URL = "/team-sessions";

export const createTeamSessionMapping = (payload) =>  api.post(API_URL, payload);

export const updateTeamSessionMapping = (teamId, sessionId, payload) =>
  api.put(`${API_URL}/${teamId}/${sessionId}`, payload);

export const deleteTeamSessionMapping = (teamId, sessionId) =>
  api.delete(`${API_URL}/${teamId}/${sessionId}`);

export const getTeamsForSession = (sessionId) =>
  api.get(`${API_URL}/sessions/${sessionId}`);

